module.exports = __webpack_public_path__ + "media/images/metronic/portlet-config-icon-3dda4338d268c50942a2e7ac1d55503e.png";